import React from "react";
import "./ProgramDescriptionBlock.css";

const ProgramDescriptionBlock = ({
  content,
  variant = "featured",
  imageSrc,
  imageAlt,
}) => {
  const lead = content?.lead?.trim() || "";
  const highlights = content?.highlights || [];
  const ageLabel = content?.ageLabel || null;

  if (!lead && highlights.length === 0) {
    return null;
  }

  return (
    <div className={`program-desc-block program-desc-block--${variant}`}>
      <div className="program-desc-block__content">
        {lead && <p className="program-desc-block__lead">{lead}</p>}

        {ageLabel && <p className="program-desc-block__age">{ageLabel}</p>}

        {highlights.length > 0 && (
          <ul className="program-desc-block__highlights">
            {highlights.map((highlight) => (
              <li
                key={`${highlight.title}-${highlight.text}`}
                className={`program-desc-block__highlight program-desc-block__highlight--${highlight.accent}`}
              >
                <h3 className="program-desc-block__highlight-title">{highlight.title}</h3>
                {highlight.text &&
                  highlight.text.toLowerCase() !== highlight.title.toLowerCase() && (
                    <p className="program-desc-block__highlight-text">{highlight.text}</p>
                  )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {variant === "featured" && imageSrc && (
        <div className="program-desc-block__image-wrap">
          <img src={imageSrc} alt={imageAlt || ""} loading="lazy" />
        </div>
      )}
    </div>
  );
};

export default ProgramDescriptionBlock;
